<template>
    <div>
        <blockquote :class="[excludeFromPrintClassName]" v-html="value.text" />
        <div
            v-if="value.button?.type === buttonTypes.CTA"
            class="d-flex align-items-center"
        >
            <a :href="value.button.url" target="_blank">
                <button class="btn btn_gray ml-2">
                    {{ value.button.text }}
                </button>
            </a>
            <span class="ml-2">
                {{ value.button.title }}
            </span>
        </div>
        <div
            v-else-if="value.button?.type === buttonTypes.EMAIL"
            class="email-form"
        >
            <div class="form">
                <form @submit.prevent="onSubmit">
                    <div class="form_inner flex flex_center">
                        <div class="form_row">
                            <input
                                v-model="email"
                                class="form_control"
                                :class="{
                                    'is-invalid': error
                                }"
                                type="email"
                                :placeholder="
                                    $t('contentBuilder.quote.enterEmail')
                                "
                                @input="error = false"
                            />
                        </div>

                        <div class="form_btn">
                            <input
                                class="btn btn_gray"
                                type="submit"
                                :value="$t('contact.form.submit')"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    },

    validations: {
        email: {
            required,
            email
        }
    },

    data() {
        return {
            email: '',
            error: false,
            buttonTypes: { CTA: 'cta', EMAIL: 'email' }
        };
    },

    methods: {
        ...mapActions({
            newsletterSignup: 'mails/newsletterSignup'
        }),

        async onSubmit() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                const error = !this.$v.email.email ? 'invalid' : 'required';

                this.$toasted.error(
                    this.$t(`volunteers.sendEmail.${error}Email`)
                );

                return;
            }

            if (!this.email) {
                this.error = true;
            }

            try {
                await this.newsletterSignup({
                    email: this.email
                });

                this.$v.$reset();

                this.email = null;

                this.$toasted.success(this.$t('newsletter.thankYouMessage'));
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        }
    }
};
</script>
